import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInputFile from "Common/Custom/FormInputFile";
import FormTextarea from "Common/Custom/FormTextarea";
import FormIconSelect from "Common/Custom/FormIconSelect";

const EditAboutUsForm = ({
    fields = [],
    values = {},
    setValues = () => { },
    errors = {},
    handleChange = () => { },
    handleArrayChange = () => { },
    handleSubmit = () => { },
    loading = false,
    handleFileChange = () => { },
    imagePreview = "",
    title = "Edit About Us",
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.name === "values_title" || field.name === "values_subtitle") {
                    return null; // These are rendered inside the values_array section
                }
                if (field.type === "alert") {
                    return (
                        <div className="alert alert-info">
                            {field.value}
                        </div>
                    )
                }
                if (field.type === "file") {
                    return (
                        <FormInputFile
                            key={field.name}
                            field={field}
                            handleChange={handleFileChange}
                            error={errors[field.name]}
                            imagePreview={field.name === "story_image" ? imagePreview : undefined}
                        />
                    );
                }

                if (field.type === "stats_array") {
                    const stats = Array.isArray(values[field.name]) ? values[field.name] : [];

                    const addStat = () => {
                        setValues({ ...values, [field.name]: [...stats, { label: "", value: "", icon: "" }] });
                    };
                    const removeStat = (index) => {
                        const newStats = [...stats];
                        newStats.splice(index, 1);
                        setValues({ ...values, [field.name]: newStats });
                    };

                    return (
                        <div key={field.name} className="col-12 mb-5">
                            <div className="p-4 bg-white shadow-sm border rounded" style={{ borderColor: '#e9ecef' }}>
                                <div className="mb-4 pb-3 border-bottom">
                                    <h4 className="mb-1 text-primary fw-bold">{field.label}</h4>
                                    <p className="text-muted small mb-0">Add, edit, or remove the individual stats that appear on your page.</p>
                                </div>

                                {stats.length === 0 && (
                                    <div className="text-center p-5 bg-light rounded border border-dashed text-muted mb-4">
                                        <p className="mb-0">No stats added yet. Click the button below to add your first stat.</p>
                                    </div>
                                )}

                                <div className="row">
                                    {stats.map((stat, index) => (
                                        <div key={index} className="col-md-6 mb-4">
                                            <div className="card h-100 shadow-none border" style={{ borderRadius: '12px', overflow: 'hidden', backgroundColor: '#f8f9fa', borderColor: '#dee2e6' }}>
                                                <div className="card-header bg-transparent border-bottom-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                                                    <h6 className="mb-0 fw-bold text-secondary">Stat #{index + 1}</h6>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger shadow-sm"
                                                        style={{ borderRadius: '6px' }}
                                                        onClick={() => removeStat(index)}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-12 mb-3">
                                                            <FormIconSelect
                                                                field={{
                                                                    name: `icon_${index}`,
                                                                    label: "Icon",
                                                                    type: "iconselect",
                                                                    fieldSize: "col-12"
                                                                }}
                                                                value={stat.icon || ""}
                                                                handleChange={(e) => handleArrayChange(field.name, index, "icon", e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <FormInput
                                                                field={{ name: `label_${index}`, label: "Label", type: "text", fieldSize: "col-12" }}
                                                                value={stat.label || ""}
                                                                handleChange={(e) => handleArrayChange(field.name, index, "label", e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <FormInput
                                                                field={{ name: `value_${index}`, label: "Value", type: "text", fieldSize: "col-12" }}
                                                                value={stat.value || ""}
                                                                handleChange={(e) => handleArrayChange(field.name, index, "value", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-2 text-center pt-3 border-top">
                                    <button type="button" className="btn btn-primary px-5 py-2 shadow-sm rounded-pill fw-bold" onClick={addStat}>
                                        + Add New Stat
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }
                if (field.type === "values_array") {
                    const valuesList = Array.isArray(values[field.name]) ? values[field.name] : [];

                    const addValue = () => {
                        setValues({ ...values, [field.name]: [...valuesList, { title: "", desc: "", icon: "" }] });
                    };
                    const removeValue = (index) => {
                        const newValues = [...valuesList];
                        newValues.splice(index, 1);
                        setValues({ ...values, [field.name]: newValues });
                    };

                    return (
                        <div key={field.name} className="col-12 mb-5">
                            <div className="p-4 bg-white shadow-sm border rounded" style={{ borderColor: '#e9ecef' }}>
                                <div className="mb-4 pb-3 border-bottom">
                                    <h4 className="mb-3 text-primary fw-bold">{field.label}</h4>

                                    {/* Sub-fields for the section */}
                                    <div className="row bg-light p-3 rounded mb-4 border">
                                        <div className="col-md-6 mb-3 mb-md-0">
                                            <FormInput
                                                field={{ name: "values_title", label: "Values Section Title", type: "text", fieldSize: "col-12" }}
                                                value={values["values_title"] || ""}
                                                handleChange={handleChange}
                                                error={errors["values_title"]}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <FormInput
                                                field={{ name: "values_subtitle", label: "Values Section Subtitle", type: "text", fieldSize: "col-12" }}
                                                value={values["values_subtitle"] || ""}
                                                handleChange={handleChange}
                                                error={errors["values_subtitle"]}
                                            />
                                        </div>
                                    </div>

                                    <p className="text-muted small mb-0">Manage the core values list with icons, titles, and descriptions below.</p>
                                </div>

                                {valuesList.length === 0 && (
                                    <div className="text-center p-5 bg-light rounded border border-dashed text-muted mb-4">
                                        <p className="mb-0">No values added yet. Click the button below to add one.</p>
                                    </div>
                                )}

                                <div className="row">
                                    {valuesList.map((valItem, index) => (
                                        <div key={index} className="col-12 mb-4">
                                            <div className="card shadow-none border" style={{ borderRadius: '12px', overflow: 'hidden', backgroundColor: '#f8f9fa', borderColor: '#dee2e6' }}>
                                                <div className="card-header bg-transparent border-bottom-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                                                    <h6 className="mb-0 fw-bold text-secondary">Value Item #{index + 1}</h6>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger shadow-sm"
                                                        style={{ borderRadius: '6px' }}
                                                        onClick={() => removeValue(index)}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3 mb-md-0">
                                                            <FormIconSelect
                                                                field={{ name: `icon_${index}`, label: "Icon", type: "iconselect", fieldSize: "col-12" }}
                                                                value={valItem.icon || ""}
                                                                handleChange={(e) => handleArrayChange(field.name, index, "icon", e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <FormInput
                                                                field={{ name: `title_${index}`, label: "Title", type: "text", fieldSize: "col-12" }}
                                                                value={valItem.title || ""}
                                                                handleChange={(e) => handleArrayChange(field.name, index, "title", e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-12 mt-2">
                                                            <FormTextarea
                                                                field={{ name: `desc_${index}`, label: "Description", type: "textarea", fieldSize: "col-12", rows: 3 }}
                                                                value={valItem.desc || ""}
                                                                handleChange={(e) => handleArrayChange(field.name, index, "desc", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-2 text-center pt-3 border-top">
                                    <button type="button" className="btn btn-primary px-5 py-2 shadow-sm rounded-pill fw-bold" onClick={addValue}>
                                        + Add New Value
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }
                if (field.type === "iconselect") {
                    return (
                        <FormIconSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                        />
                    );
                }
                if (field.type === "textarea") {
                    return (
                        <FormTextarea
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update About Us"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditAboutUsForm;
